export default __webpack_public_path__ + "static/media/approval-workflow-outline-16px.04e39bfc.svg";